import React, { useEffect } from "react";
import { styled, Box, Modal, Typography, TextField, Button } from "@mui/material";
import { IWithClassName } from "../../../theme/default.theme";
import { useAppDispatch } from "../../../redux/store";
import { saveTrackierThunk } from "../../../redux/thunks/campaign.thunk";

interface IProps extends IWithClassName {
  open: boolean;
  handleClose: () => void;
  trackierIds: Array<string>;
  campaignId: string;
}

const TrackierModel = ({ className, open, handleClose, trackierIds, campaignId }: IProps) => {
  const dispatch = useAppDispatch();
  
  const [newTrackierIds, setTackeirIds] = React.useState<Array<string>>([]);

  useEffect(() => setTackeirIds(trackierIds) , [trackierIds]);

  const handleAddTrackier = async() => {
    await dispatch(saveTrackierThunk(campaignId, newTrackierIds));
    handleClose();
  }

  return (
    <Modal
        className={className}
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title" aria-describedby="modal-description"
    >
        <Box>
            <Typography variant="h6" component="h2" id="modal-title">
                Trackier Ids
            </Typography>
            <Box id="modal-description">
              <TextField
                label="Trackier Id"
                variant="outlined"
                onChange={(e) => setTackeirIds(e.target.value.split(", "))}
                value={newTrackierIds.join(", ")}
                fullWidth
                margin="normal"
                size="small" />
            </Box>
            <Button variant="contained" color="primary" fullWidth onClick={handleAddTrackier}>
              Add Trackier
            </Button>
        </Box>
    </Modal>
  );
}

export default styled(TrackierModel)(() => ({
  width: 300,
  height: 300,
  top: "50%",
  left: "50%",
  backgroundColor: "white",
}));